var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"accept":".dat","label":"File memory (fixed length mapping 13 + 5)","show-size":"","outlined":"","dense":"","multiple":"","disabled":_vm.disabled,"prepend-icon":"","prepend-inner-icon":"$file"},on:{"change":_vm.onChange},model:{value:(_vm.filename),callback:function ($$v) {_vm.filename=$$v},expression:"filename"}})
}
var staticRenderFns = []

export { render, staticRenderFns }